const ITEMS = [
  "Daily valet collection",
  "6–9 AM & 6–9 PM windows",
  "$1M/$2M liability insured",
  "Zero hallway clutter",
  "Tied bags only",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative py-6 border-y border-white/5 overflow-hidden bg-ink/60" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-bold text-sm sm:text-base uppercase tracking-[0.2em] text-parchment/25 px-8">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rotate-45 bg-terracotta/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
